<template>
  <form class="woocommerce-cart-form" @submit.prevent>
    <table
      class="shop_table shop_table_responsive cart woocommerce-cart-form__contents"
      cellspacing="0"
      v-if="cart.qty"
      :key="keyCartList"
    >
      <thead>
        <tr>
          <th class="product-remove">&nbsp;</th>
          <th class="product-thumbnail">&nbsp;</th>
          <th class="product-name">{{ $t('product') }}</th>
          <th class="product-price">{{ $t('price') }}</th>
          <th class="product-quantity">{{ $t('quantity') }}</th>
          <th class="product-subtotal">{{ $t('subtotal') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="woocommerce-cart-form__cart-item cart_item"
          v-for="(item, idx) in cartItems"
          :key="`item_${idx}`"
        >
          <td class="product-remove">
            <a
              v-if="item.isWarranty"
              href="#"
              class="remove"
              @click.stop.prevent="onRemoveWarranty(item.id)"
            >
              ×
            </a>
            <a
              v-else-if="!item.isProfit"
              href="#"
              class="remove"
              :aria-Label="$t('removePosition')"
              @click.stop.prevent="onRemoveItem(item)"
            >
              ×
            </a>
          </td>
          <td class="product-thumbnail">
            <router-link
              :to="lang ? '/' + lang + item.link : item.link"
              v-if="!item.isWarranty"
            >
              <img
                loading="lazy"
                width="540"
                height="540"
                :src="productImg(item)"
                class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail lazyloaded"
                :alt="productName(item)"
              />
            </router-link>
          </td>
          <td class="product-name" :data-title="$t('product')">
            <span v-if="item.isWarranty">{{ item.name }}</span>
            <router-link :to="lang ? '/' + lang + item.link : item.link" v-else>
              {{ productName(item) }}
            </router-link>
          </td>
          <td class="product-price" :data-title="$t('price')">
            <span
              style="margin-left: 50px; white-space: nowrap"
              class="price-ukr"
              v-if="!item.isWarranty"
              v-html="$h.formatPrice(productPrice(item))"
            />грн
          </td>
          <td class="product-quantity" :data-title="$t('quantity')">
            <span class="waranty-quantity" v-if="item.isWarranty"
              >1
              <!-- <input
                type="number"
                disabled="disabled"
                class="input-text qty text"
                size="4"
                ref="qtys"
                value="1"
                :data-id="item.id"
              /> -->
            </span>
            <div class="quantity" v-else>
              <label class="screen-reader-text" :for="`quantity_${item.id}`">
                {{ $t('quantity') }} {{ productName(item) }}
              </label>
              <input
                type="number"
                class="input-text qty text"
                :id="idx"
                step="1"
                min="1"
                max=""
                size="4"
                inputmode="numeric"
                ref="qtys"
                @change="onChangeQty(idx)"
                :value="item.qty"
                :data-id="item.id"
              />
            </div>
          </td>
          <td class="product-subtotal" :data-title="$t('subtotal')">
            <span
              style="margin-left: auto"
              class="price-ukr"
              v-if="item.isWarranty"
            >
              <span v-html="$h.formatPrice(productPrice(item))"></span>грн
            </span>
            <span
              style="margin-left: 50px; white-space: nowrap"
              class="price-ukr"
              v-if="!item.isWarranty"
              v-html="$h.formatPrice(productPrice(item)) + 'грн'"
            ></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="wc-proceed-to-checkout" v-if="cart.qty">
      <router-link
        :to="lang ? '/' + lang + '/checkout' : '/checkout'"
        class="checkout-button button alt wc-forward"
      >
        {{ $t('checkout') }}
      </router-link>
    </div>
    <div class="woocommerce" v-else>
      <div>
        <!--<div class="woocommerce-message" role="alert">
        “Apple AirPort Time Capsule 2 TB (ME177)” видалено.
        this.$t(deleteTemplate, {name})
        <a href="" class="restore-item">
        Відмінити?
        </a>
        </div>-->
        <p class="cart-empty">{{ $t('cartIsEmpty') }}</p>
      </div>
      <p class="return-to-shop">
        <router-link class="button wc-backward" :to="lang ? '/' + lang : '/'">
          {{ $t('backToShop') }}
        </router-link>
      </p>
    </div>
    <div v-if="accessoriesProducts.length">
      <div>
        <div class="h3" id="accessories" style="margin-top: 30px">
          {{ $t('accessories') }}
        </div>
        <button-scroll-to-accessories :lang="lang" />
      </div>
      <div>
        <accesories-products :products="accessoriesProducts" />
      </div>
    </div>
  </form>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import CartMixin from '@/components/cart/CartMixin'
import AccesoriesProducts from '@/components/product/AccesoriesProducts'
import ButtonScrollToAccessories from '@/components/static/ScrollToAccessories'

export default {
  name: 'Cart',
  components: { AccesoriesProducts, ButtonScrollToAccessories },
  mixins: [CartMixin],
  data() {
    return {
      keyCartList: '0cartlist',
      lang: '',
    }
  },
  computed: {
    accessoriesProducts() {
      if (this.category && this.category.accesorries) {
        return this.category.accesorries
      }
      return []
    },
  },
  methods: {
    onRemoveWarranty(id) {
      this.removeWarranty(id)
    },
    onChangeQty(i) {
      let qty = this.$refs.qtys[i].value

      if (qty == 0) {
        qty = 1
      }

      this.setCartItemQty({
        id: this.$refs.qtys[i].getAttribute('data-id'),
        qty,
      })
      this.keyCartList = `${parseInt(this.keyCartList) + 1}cartlist`
    },
    productPrice(item) {
      return item.qty * (item.newPrice ? item.newPrice : item.price)
    },
  },
  beforeMount() {
    this.$store.dispatch('setHeadline', this.$t('title.cart'))
    this.$store.dispatch('setBreadcrumbs', [{ name: this.$t('cart') }])
    let accs = []
    this.cart.items.forEach((item) => {
      let ids = item.categoryPath.split('/')
      let cat = this.$store.state.categories.find((c) => c.id === ids[0])
      if (cat) {
        cat = cat.children.find((c) => c.id === ids[1])
        if (cat && cat.accessories && Array.isArray(cat.accessories)) {
          accs = accs.concat(cat.accessories)
        }
      }
    })
    if (accs.length) {
      this.$store.commit('setCategoryAccesorries', accs)
    }
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
  mounted() {
    this.$h.gtmDataLayerPush({
      ecomm_pagetype: 'cart',
      ecomm_prodid: this.cartItems.map(({ did }) => did),
      ecomm_totalvalue: this.cartItems.reduce(
        (sum, item) => sum + this.productPrice(item),
        0
      ),
    })
    const item_list_id = uuidv4()
    this.$gtag.event('view_cart', {
      items: this.cartItems.map((item) => {
        const { name, did, price, qty } = item
        return {
          item_name: name,
          item_id: did,
          price: price,
          currency: 'UAH',
          item_brand: 'Apple',
          item_category: this.categoryName(item),
          item_list_name: 'Cart list',
          item_list_id,
          quantity: qty,
        }
      }),
    })
  },
}
</script>
<style>
.waranty.waranty-quantity > input.input-text.qty.text {
  border: none;
  color: rgba(68, 68, 68, 0.7);
}
</style>
